import { createSlice } from '@reduxjs/toolkit';
import { stat } from 'fs';
interface LoadingSlice {
    isActive: boolean
}


const initialState: LoadingSlice = {
    isActive: false
}

const loadingSlice = createSlice({
    name: 'loading',
    initialState,
    reducers: {
        setMainLoading(state, action: { payload: boolean }) {
            state.isActive = action.payload;
        }
    }
});

export const {
    setMainLoading
} = loadingSlice.actions;

export default loadingSlice.reducer;